import { fetch } from 'wix-fetch'
import wixLocation from 'wix-location'
import { biLoggerFactory } from 'wix-private'

let cacheKillerCounter = 0

const getCacheKiller = () => {
	return new Date().getTime() + cacheKillerCounter++;
};

const defaultParams = {
	page_url: encodeURIComponent(wixLocation.url),
	msid: '51916564-3e3a-4edb-93dc-01adce806ce0',
	session_id: self.fedops.sessionId
}

export const sendBI = (evid, params = {}) => {
	const platformBiLogger = biLoggerFactory('platform-cm', 83);

	const mergedParams = Object.assign({}, defaultParams, params, { evid })
	return platformBiLogger.log(mergedParams);
}